module.exports = __webpack_public_path__ + "static/don11-708a2fbc464a6e5409e9bc81f0a0800a.jpg";